export const getMaxTableHeight = (tableId, tableHeight = 800) => {
	const el = document.getElementById(tableId)
	const offset = el?.getBoundingClientRect()?.top ?? 0
	const height = window.innerHeight - offset - 100 // 100 - distance to the bottom of the screen
	return height > tableHeight ? height : tableHeight
}
